import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDAutoCompleteInput } from '@facet-wealth/design';
import { _stringMetaFieldShowCharacterCount } from 'Components/UI/Meta/MetaControl/Types/String';
import AdditionalDetails
  from 'Views/Page/Content/Templates/WhatIfTemplate/Components/NextUpTimeline/Accordion/Overrides/AdditionalDetails';

export default buildFacetDesignOverride()
  .overrideAll({
    _customProps: {
      fullWidth: true,
    },
  }, overrideReadOnly)
  .nameOverride(['outcomeNames'], {
    hidden: false, // This should not need to be here but is needed because all readonly fields are hidden in a previous override.
    _component: () => AdditionalDetails,
  }, overrideReadOnly)
  .nameOverride('title', {
    hidden: true,
  }, overrideReadOnly)
  .override({
    name: 'name',
    readonly: false,
  }, {
    [_stringMetaFieldShowCharacterCount]: true,
  }, overrideReadOnly)
  .nameOverride('proposedScenarios', {
    _component: () => FDAutoCompleteInput,
    _customProps: {
      multiple: true,
      required: true,
      helperText: '',
      fullWidth: true,
    },
  }, overrideReadOnly);
